import iconQuestionSmall from "images/iconQuestionSmall.svg";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import "./tooltip.scss";

const Tooltip = ({
  text,
  noIcon,
  Component,
  openModal,
  position = "right"
}) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <div className="info-tooltip position-relative">
        <div className="info-tooltip-container-desk">
          {noIcon ? (
            <Component />
          ) : (
            <img src={iconQuestionSmall} alt="" className="info-tooltip__img" />
          )}
          {text ? (
            <p className={`info-tooltip__text m-0 ${position}`}>{text}</p>
          ) : null}
        </div>

        <div className="info-tooltip-container-mob">
          {noIcon ? (
            <div onClick={() => openModal && setShow(true)}>
              <Component />
            </div>
          ) : (
            <img
              src={iconQuestionSmall}
              alt=""
              className="info-tooltip__img"
              onClick={() => {
                setShow(true);
              }}
            />
          )}
        </div>
      </div>

      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        size="xl"
        centered
        show={show}
        contentClassName="tooltip-modal"
        backdrop="static"
      >
        <div className="d-flex flex-column">
          <p className="m-0">{text}</p>
          <div className="align-self-end">
            <button
              type="button"
              id="closeTooltipModal"
              onClick={() => setShow(false)}
              className="btn-OK"
            >
              ОК
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Tooltip;
